import { HTTP_DESKRH } from '../http';

export default {
  addChorusDoc(params) {
    return HTTP_DESKRH.post('/guichet-cpp/upload', params);
  },

  searchService(siret) {
    return HTTP_DESKRH.get(`/guichet-cpp/structure/${siret}`);
  },

  updateChorusConf(chorusConf) {
    return HTTP_DESKRH.post('/guichet-cpp/configure', chorusConf);
  },
};



// WEBPACK FOOTER //
// ./src/api/chorus.js